module.exports = __webpack_public_path__ + "static/media/logo1.d34fa4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = 160
// module chunks = 0